/**
 * BM25 term-document score with field-length normalization.
 *
 * Constants follow the standard recommendations from the original Robertson
 * et al. paper. They are exposed as named consts so a future tuning sweep
 * (if relevance ever drifts) has a single place to change.
 */

const K1 = 1.4; // term-frequency saturation — higher = TF matters more
const B = 0.75; // length normalization — 1 = full, 0 = none

export function bm25Score(
  tf: number,
  df: number,
  N: number,
  fieldLen: number,
  avgFieldLen: number,
): number {
  if (tf <= 0 || df <= 0 || N <= 0) return 0;
  const idf = Math.log(1 + (N - df + 0.5) / (df + 0.5));
  const denom = tf + K1 * (1 - B + (B * fieldLen) / (avgFieldLen || 1));
  const norm = (tf * (K1 + 1)) / denom;
  return idf * norm;
}
